module.exports = __webpack_public_path__ + "static/img/102270.b48a220f.png";